import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import Router from 'next/router'
import clsx from 'clsx'
import ResponsiveImage from 'components/images/responsive-image'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { SEGMENT_STORAGE_KEY_CATEGORY } from 'lib/segment/const'
import env from 'config/env'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import { withI18next } from 'lib/i18n/withI18next'
import YellowSection from '../yellow-section'

const STATIC_CONTENTS = {
  img1: {
    th: {
      en: `${env.IMG_HOST}img/pomelo-cares/desktop-en-1.jpg`,
      th: `${env.IMG_HOST}img/pomelo-cares/desktop-th-1.jpg`,
    },
    sg: {
      en: `${env.IMG_HOST}img/pomelo-cares/desktop-en-1.jpg`,
    },
    id: {
      id: `${env.IMG_HOST}img/pomelo-cares/desktop-id-1.jpg`,
    },
    my: {
      en: `${env.IMG_HOST}img/pomelo-cares/desktop-my-1.jpg`,
    },
    ratio: 0.771,
  },
  img2: {
    th: {
      en: `${env.IMG_HOST}img/pomelo-cares/desktop-en-2.jpg`,
      th: `${env.IMG_HOST}img/pomelo-cares/desktop-th-2.jpg`,
    },
    sg: {
      en: `${env.IMG_HOST}img/pomelo-cares/desktop-en-2.jpg`,
    },
    id: {
      id: `${env.IMG_HOST}img/pomelo-cares/desktop-id-2.jpg`,
    },
    my: {
      en: `${env.IMG_HOST}img/pomelo-cares/desktop-my-2.jpg`,
    },
    ratio: 0.3845,
  },
  img3: {
    th: {
      en: `${env.IMG_HOST}img/pomelo-cares/desktop-en-3.jpg`,
      th: `${env.IMG_HOST}img/pomelo-cares/desktop-th-3.jpg`,
    },
    sg: {
      en: `${env.IMG_HOST}img/pomelo-cares/desktop-en-3.jpg`,
    },
    id: {
      id: `${env.IMG_HOST}img/pomelo-cares/desktop-id-3.jpg`,
    },
    my: {
      en: `${env.IMG_HOST}img/pomelo-cares/desktop-my-3.jpg`,
    },
    ratio: 0.8545,
  },
  paypalLinks: {
    th: {
      en: 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=CTRBJQYWTZGGE',
      th: 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=5RFK9CH4YGJ9A',
    },
    id: {
      id: 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=3ZBFTYX5ST8Q2',
    },
    sg: {
      en: 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=JBQNA6DEW822Y',
    },
    my: {
      en: 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=3ZBFTYX5ST8Q2',
    },
  },
}

const DesktopContent = ({ country, isThankYouPage, language, t }) => {
  if (isThankYouPage) {
    return (
      <YellowSection
        country={country}
        isDesktop
        isThankYouPage
        language={language}
        t={t}
      />
    )
  }

  const as = `/${country}/${language}/features/shop-and-donate-mask`

  const goToCategory = (e) => {
    e.preventDefault()
    e.stopPropagation()
    sessionStorage.setItem(SEGMENT_STORAGE_KEY_CATEGORY.id, 'pomelocares')
    sessionStorage.setItem(SEGMENT_STORAGE_KEY_CATEGORY.position, '')
    sessionStorage.setItem(SEGMENT_STORAGE_KEY_CATEGORY.type, 'landing_page')
    sessionStorage.setItem(SEGMENT_STORAGE_KEY_CATEGORY.subPos, '')
    Router.push(`/category?id=2090`, as)
  }

  const isOneBtn = country === 'my'

  return (
    <React.Fragment>
      <ResponsiveImage
        imgRatio={STATIC_CONTENTS.img1.ratio}
        lazy={false}
        src={STATIC_CONTENTS.img1[country][language]}
      />
      <ResponsiveImage
        imgRatio={STATIC_CONTENTS.img2.ratio}
        src={STATIC_CONTENTS.img2[country][language]}
      />
      <ResponsiveImage
        imgRatio={STATIC_CONTENTS.img3.ratio}
        src={STATIC_CONTENTS.img3[country][language]}
      >
        <div className={clsx('pomelo-cares-desktop', { 'one-btn': isOneBtn })}>
          {!isOneBtn && (
            <Link href={as}>
              <Button
                link
                onClick={(e) => goToCategory(e)}
                type={BUTTON_TYPES.outlinedLight}
                className="link-btn"
              >
                {hasLocizeTranslation(
                  t,
                  'POMELO_CARE_DESKTOP_CTA_1',
                  'SHOP & DONATE MASKS',
                )}
              </Button>
            </Link>
          )}
          <Link href={STATIC_CONTENTS.paypalLinks[country][language]}>
            <Button
              link
              target="_blank"
              aProps={{ rel: 'noopener noreferrer nofollow' }}
              type={BUTTON_TYPES.outlinedLight}
              className="link-btn"
            >
              {hasLocizeTranslation(
                t,
                'POMELO_CARE_DESKTOP_CTA_2',
                'DONATE VIA PAYPAL',
              )}
            </Button>
          </Link>
        </div>
      </ResponsiveImage>
    </React.Fragment>
  )
}

DesktopContent.propTypes = {
  country: PropTypes.string.isRequired,
  isThankYouPage: PropTypes.bool.isRequired,
  language: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

const Extended = withI18next(['global'])(DesktopContent)

export default Extended
